<template>
  <v-container fluid>
    <v-row>
      <!-- Bloc à gauche -->
      <v-col cols="12" md="4">
        <v-card class="pa-2">
          <v-card-title>
            <h4>Détails de l'exclusion</h4>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <b>Nom du cabinet / entreprise :</b>
            {{ this.$store.getters["Auth/get_selected_exclusion"].nomCabinet }}
            <v-spacer class="my-1"></v-spacer>

            <b>Sigle du cabinet / entreprise :</b>
            {{ this.$store.getters["Auth/get_selected_exclusion"].sigle }}
            <v-spacer class="my-1"></v-spacer>

            <b>RCCM :</b>
            {{ this.$store.getters["Auth/get_selected_exclusion"].rccm }}
            <v-spacer class="my-1"></v-spacer>

            <b>NIF :</b>
            {{ this.$store.getters["Auth/get_selected_exclusion"].nif }}
            <v-spacer class="my-1"></v-spacer>

            <b>Début de la sanction :</b>
            {{ this.$store.getters["Auth/get_selected_exclusion"].dateDebutSanction | moment("Do - MM - YYYY") }}
            <v-spacer class="my-1"></v-spacer>

            <b>Fin de la sanction :</b>
            {{ this.$store.getters["Auth/get_selected_exclusion"].dateFinSanction | moment("Do - MM - YYYY") }}
            <v-spacer class="my-1"></v-spacer>

            <b>Réference de la décision :</b>
            {{ this.$store.getters["Auth/get_selected_exclusion"].referenceDecision }}
            <v-spacer class="my-1"></v-spacer>

            <b>Motif :</b>
            {{ this.$store.getters["Auth/get_selected_exclusion"].motifExclusion }}
            <v-spacer class="my-1"></v-spacer>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- Bloc à droite avec le formulaire -->
      <v-col cols="12" md="8">
        <v-card>
          <v-card-title>
            <h4>Mettre à jour {{ this.$store.getters["Auth/get_selected_exclusion"].nomCabinet }}</h4>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <!-- Formulaire avec trois champs -->
            <v-form @submit.prevent="submitForm">
              <v-text-field v-model="exclusionData.nomCabinet" label="Nom du cabinet / Raison sociale"></v-text-field>
              <v-row>
                <v-col cols="6">
                  <v-text-field v-model="exclusionData.rccm" label="N° RCCM"></v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field v-model="exclusionData.nif" label="N° NIF"></v-text-field>
                </v-col>
              </v-row>
              <v-text-field v-model="exclusionData.sigle" label="Sigle"></v-text-field>
              <v-text-field v-model="exclusionData.referenceDecision" label="Référence de la décision"></v-text-field>
              <v-textarea v-model="exclusionData.motifExclusion" label="Motif de l’exclusion"></v-textarea>
              <v-row>
              <!-- <v-col cols="6">
                <label>Date début sanction</label>
                <date-picker v-model="exclusionData.dateDebutSanction" value-type="format" format="YYYY-MM-DD" placeholder="Indiquer la date de début de la sanction" type="date"></date-picker>
              </v-col>
              <v-col cols="6">
                <label>Date fin sanction</label>
                <date-picker v-model="exclusionData.dateFinSanction" value-type="format" format="YYYY-MM-DD" placeholder="Indiquer la date de fin de la sanction" type="date"></date-picker>
              </v-col> -->
            </v-row>
              <v-card-actions>
                <v-btn small type="submit" medium outlined color="primary" dark>Envoyer</v-btn>
              </v-card-actions>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
    
<script>
import moment from 'moment';
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
export default {
  components: { DatePicker },
  props: {
    id: {
      type: Number,
      required: true
    }
  },
  data: () => ({
    exclusionData: {
      nomCabinet: "",
      rccm: "",
      nif: "",
      sigle: "",
      referenceDecision: "",
      motifExclusion: "",
      dateDebutSanction: null,
      dateFinSanction: null,
    },
  }),

  created() {
    // this.$store.dispatch("Auth/loadExclusionById", this.id);
    this.loadExclusionData();
  },
  methods: {
    async loadExclusionData() {
      try {
        // Appel à l'action Vuex pour charger les données d'exclusion
        await this.$store.dispatch("Auth/loadExclusionById", this.id);

        // Mise à jour de exclusionData avec les données récupérées
        const exclusion = this.$store.getters["Auth/get_selected_exclusion"];
        this.exclusionData = { ...exclusion }; // Mise à jour des données d'exclusion
      } catch (error) {
        console.error("Erreur lors du chargement de l'exclusion:", error);
      }
    },

    submitForm() {
      const data = new FormData();
      data.append("nomCabinet", this.exclusionData.nomCabinet);
      data.append("rccm", this.exclusionData.rccm);
      data.append("nif", this.exclusionData.nif);
      data.append("sigle", this.exclusionData.sigle);
      data.append("referenceDecision", this.exclusionData.referenceDecision);
      data.append("motifExclusion", this.exclusionData.motifExclusion);
      data.append("dateDebutSanction", this.exclusionData.dateDebutSanction);
      data.append("dateFinSanction", this.exclusionData.dateFinSanction);
      // Ajoutez l'identifiant de l'exclusion à mettre à jour
      data.append("exclusionId", this.id);

      console.log("IDENTIFIANT", this.id)
      this.$store.dispatch("Auth/updateExclusion", data);
    },


  }
};
</script>
    
<style>
.vue-daterange-picker {
  width: 100% !important;
}

.mx-datepicker {
  width: 100% !important;
}

.w-62em {
  height: 62em !important;
  width: 100% !important;
}

.date-picker-wrapper {
  margin-bottom: 16px;
}

.date-picker-wrapper label {
  font-weight: bold;
}
</style>
    